import SectionForm, { useFormContext } from "../SectionForm"
import { Textarea } from "@/components/ui"

const FieldList = [
  {name: "toiture", label: "Etat toiture"},
  {name: "facade", label: "Etat façade"},
  {name: "sinistres", label: "Sinistres"},
  {name: "travaux", label: "Travaux"},
  {name: "assurances", label: "Assurances D/O + date"},
]

const FormContent = () => {
  const { control } = useFormContext()
  return (
    <>
      {FieldList.map( ({name, label}, index) => (
        <div key={index} className="flex flex-col items-start gap-4">                
          <Textarea.Form 
            key={index}
            control={control} 
            name={name}
            label={label}
          />
        </div>
      ))}
    </>
  )
}

export default ({ title = "", onClose = () => {}, onSuccess = () => {} }) => (
  <SectionForm
    title={title}
    onClose={onClose}
    onSuccess={onSuccess}
    fields={FieldList.map( f => f.name)}
    columns={5}
  >
    <FormContent/>
  </SectionForm>
)